import { render } from "./TitleProperty.vue?vue&type=template&id=0c356827&scoped=true"
import script from "./TitleProperty.vue?vue&type=script&lang=js"
export * from "./TitleProperty.vue?vue&type=script&lang=js"

import "./TitleProperty.vue?vue&type=style&index=0&id=0c356827&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c356827"]])

export default __exports__